import { Component, Input } from '@angular/core';

import { StockItemCommentService } from '../../../services';

@Component({
  selector: 'app-stock-item-comments',
  templateUrl: './stock-item-comments.component.html',
  styleUrl: './stock-item-comments.component.scss',
})
export class StockItemCommentsComponent {
  @Input() id = '';
  @Input() isModal = false;
  @Input() showSave = false;
  @Input() showBack = false;
  @Input() oneRecord = false;
  @Input() allowAdd = true;

  constructor(public stockItemCommentService: StockItemCommentService) {}
}
